module.exports = __webpack_public_path__ + "img/main_view_bg.bf51e362.svg";